import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-80" data-mp="1ge8u4k5d09qw">
      <div className="mx-auto max-w-3xl" data-id="element-81" data-mp="2e0ps7rlx2rdp">
        <SectionHeading eyebrow="Dudas frecuentes" title="Preguntas frecuentes de colegas" data-id="element-82" data-mp="2dzobp7m4tcol" />

        <div className="mt-12 space-y-3" data-id="element-83" data-mp="2924nbevpzjix">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <Reveal key={faq.q} delay={index * 0.04} data-id="element-84" data-mp="1z3714ilro233" data-mpi={index}>
                <div className={`overflow-hidden rounded-2xl border-2 bg-white transition-colors duration-200 ease-out ${isOpen ? 'border-brand' : 'border-ink/15'}`} data-id="element-85" data-mp="1z2nit0s7fboj">
                  <h3 data-id="element-86" data-mp="nnqrtlcgmcej">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/40 sm:px-7" data-id="element-87" data-mp="nmgskstvey6b">
                      <span className="font-display text-lg leading-tight text-ink sm:text-xl" data-id="element-88" data-mp="fkjkvker1d1l">
                        {faq.q}
                      </span>
                      <span className={`inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-ink transition-[transform,background-color,color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-brand text-white' : 'bg-volt text-ink'}`} data-id="element-89" data-mp="kko5nmmowtxm">
                        <PlusIcon className="h-4 w-4" aria-hidden="true" strokeWidth={3} data-id="element-90" data-mp="3t07so3wrpg48" />
                      </span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-91" data-mp="3jxq59m5dmhfn">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-92" data-mp="3k0cerrbtv70i">
                        <p className="px-6 pb-6 text-base leading-relaxed text-ink/70 sm:px-7" data-id="element-93" data-mp="1fsq4cthbc28b">
                          {faq.a}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}